// extracted by mini-css-extract-plugin
module.exports = {"root":"root___2P-BO","message":"message___3RcTn"};